var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyExeNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5696 15.3292C4.2152 13.6048 1 10.7563 1 8.06307C1 3.56358 5.4 1.88354 9 5.35833C12.6 1.88354 17 3.56358 17 8.06231C17 10.7563 13.784 13.6048 11.4304 15.3292C10.3648 16.1092 9.832 16.5 9 16.5C8.168 16.5 7.6352 16.11 6.5696 15.3292ZM12.6 5.98539C12.7591 5.98539 12.9117 6.04581 13.0243 6.15337C13.1368 6.26092 13.2 6.4068 13.2 6.55891V7.51478H14.2C14.3591 7.51478 14.5117 7.57521 14.6243 7.68277C14.7368 7.79032 14.8 7.9362 14.8 8.08831C14.8 8.24042 14.7368 8.38629 14.6243 8.49385C14.5117 8.60141 14.3591 8.66183 14.2 8.66183H13.2V9.61771C13.2 9.76982 13.1368 9.91569 13.0243 10.0233C12.9117 10.1308 12.7591 10.1912 12.6 10.1912C12.4409 10.1912 12.2883 10.1308 12.1757 10.0233C12.0632 9.91569 12 9.76982 12 9.61771V8.66183H11C10.8409 8.66183 10.6883 8.60141 10.5757 8.49385C10.4632 8.38629 10.4 8.24042 10.4 8.08831C10.4 7.9362 10.4632 7.79032 10.5757 7.68277C10.6883 7.57521 10.8409 7.51478 11 7.51478H12V6.55891C12 6.4068 12.0632 6.26092 12.1757 6.15337C12.2883 6.04581 12.4409 5.98539 12.6 5.98539Z",
    fill: "#535B66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyExeNav);
export default __webpack_public_path__ + "static/media/MyExeNav.6f7e59f24b88841e5a78858fc171fcc3.svg";
export { ForwardRef as ReactComponent };